import Constant from '@/constant';

export default {   
    profile: {
        name: "",
        registration_number: "",
        phone_number: "",
        height: "",
        weight: "",
        underlying_disease: ""
    },
    profile_specify: {
        name: '',
        registration_number: "",
    },
    agreements: {
        agreement_personal_info: false,
        agreement_location_service: false,
        agreement_marketing: false,
        agreement_terms_condition_description: false
    },
    card_info: {
        card_number: "",
        card_pw: "",
        card_ex_month: "",
        card_ex_year: "",
        card_nick_name: "",
        card_user_name: "",
        card_user_birth: ""
    },

    temp_contract: {
        selectedType: -1,
        selectedRange: 1,
        curDate: '',
        endDate: '',
        allAgree: false,
        agreement_personal_info: false,
        agreement_terms_condition_description: false,
        name: '',
        birth: '',
        relation: -1,
        etcRelation: null,
        phoneNumber: '',
        signImageUrl: null,
        sign_file: null,
        id_card_file: null
    },

    status: {
        is_staging: false,
        is_duplicate: false,
        is_loading: false,  // 작성중인지 표시 (페이지에 직접 접근할경우 초기 화면으로 이동시킴 )
        profile_id: 0,
        // staging_data_index: 0,
        duplicate_delegation_info: {
            is_delegated: false, 
            started_date: "", // 위임청구에 동의하지 않은 경우 null
            expired_date: "", // 위임청구에 동의하지 않은 경우 null
        },
        registerd_card_info: {
            card_name: "",
            card_nick_name: "",
            card_number: ""
        }
    },

    files: {
        premedical_files: [],
        signature_file: null,
        delegation_docs_file: null, 
        id_card_file: null,
    },
    new_request_data: {
        barocare_client_id: process.env.BAROCARE_CLINET_ID,
        staging_data_index: 0,
        profile: {
            name: "",
            registration_number: "",
            address: null,
            detail_address: null,
            zip_code: null,
            address_nickname: null
        },
        card_info: {
          card_number: "",
          card_pw: "",
          card_ex_month: "",
          card_ex_year: "",
          card_nick_name: "",
          card_user_name: "",
          card_user_birth: ""
        }
    },

    revisit_request_data: {      // new, revisit 같은 router로 보내기, agreement 삭제 
        barocare_client_id: process.env.BAROCARE_CLINET_ID,
        staging_data_index: 0,
        profile: {
            name: "",
            registration_number: "",
            address: null,
            detail_address: null,
            zip_code: null,
            address_nickname: null
        },
        card_info: {
            card_number: "",
            card_pw: "",
            card_ex_month: "",
            card_ex_year: "",
            card_nick_name: "",
            card_user_name: "",
            card_user_birth: ""
        }
    },

    cardchange_request_data: {
        barocare_client_id: process.env.BAROCARE_CLINET_ID,
        profile: {
            name: "",
            registration_number: "",
            address: null,
            detail_address: null,
            zip_code: null,
            address_nickname: null
        },
        card_info: {
            card_number: "",
            card_pw: "",
            card_ex_month: "",
            card_ex_year: "",
            card_nick_name: "",
            card_user_name: "",
            card_user_birth: ""
        }
    },

    body: {
        barocare_client_id: process.env.BAROCARE_CLINET_ID,
        profile: {
            name: "",
            registration_number: "",
            address: null,
            detail_address: null,
            zip_code: null,
            address_nickname: null,
            address_description: null
        },
        // agreements: {
        //     agreement_marketing: false,
        //     agreement_sensitive_info: false,
        //     agreement_personal_info: false,
        //     agreement_terms_condition_description: false
        // },
        diabetes_type: null,         // 신규 추가
        agreement_personal_info: false,  // (개인정보 수집 및 동의)신규 추가
        agreement_sensitive_info: false, // (민감정보 수집 및 동의)신규 추가
        premedical_info: {
            phone_number: "",
            file_list: []
        },
        delegation_info: {
            agreement_delegate: true,
            agreement_personal_info: true,
            agreement_personal_identification_info: true,
            delegates_profile: null,
            // {
            //     type: "",
            //     name: "",
            //     birth: "",
            //     relationship: "",
            //     etc: "",
            //     phone_number: "",
            //     started_at: "2024-11-14T07:14:19.652Z",
            //     expired_at: "2024-11-14T07:14:19.652Z"
            // },
            file_list: null
            // {
            //     signature: {
            //         url: "",
            //         name: "",
            //         size: 0,
            //         type: ""
            //     },
            //     delegation_docs: {
            //         url: "",
            //         name: "",
            //         size: 0,
            //         type: ""
            //     },
            //     id_card: {
            //         url: "",
            //         name: "",
            //         size: 0,
            //         type: ""
            //     }
            // }
        }
    
    },
    diabetes_profiles : [],
    diabetes_settlement: {
        settlements: []
    },
    diabetes_histories: {
        total_count: 0,
        histories: []
    },
    diabetes_documents: {
        prescriptions: [],
        purchase_docs: []
    },
    pharmacies: [],
    sharedPharmacy: null,
    checkPharmacyList: [],
    // 약국 지도 약품 필터 (선택한 인슐린 약품명, 바크시미 여부)
    pharmacyMedicineFilter: {
        insulins: [],
        baqsimi: false
    },
    // 약국 지도에서 확보한 사용자 현재 위치 { latitude, longitude }. 아직 못 받았으면 null
    pharmacyUserLocation: null,
    vocPage: {
        pageno: 1,
        pagesize: 300,
        totalcount: 0,
        allCount: 0,
        vocs: []
    },
    vocDiabetes: {
        id: 0,
        contents: '',
        likeCount: 0,
        yearCount: 0,
        createdAt: null,
        updatedAt: null,
        nickName: null,
        phoneNumber: null
    },
    vocLoginKakaoToken: null,
    draftProfile: {// 위임하는 사람 프로필 생성 
        diabetes_type: "TYPE1",
        name: "",
        registration_number: "",
        phone_number: "",
        address: "",
        detail_address: "",
        zip_code: "",
        address_nickname: "",
        address_description: "",
        agreement_personal_info: true,
        agreement_sensitive_info: true
    },
    delegateWithAddition: {
        signature_file: null,
        delegation_docs_file: null,
        id_card_file: null,
        agreement_delegate: false,
        agreement_personal_info: false,
        agreement_personal_identification_info: false,
        started_at: '',
        expired_at: '',
        writer_type: 0,
        writer_name: '',  // 작성자 정보 
        writer_birth: '',
        writer_phone_number: '',
        writer_relationship: 0,
        writer_relationship_description: '',
        additional_info: {            
            is_injection_insulin: false,
            person_type: null,  // LOW_INCOME, NATIONAL_BASIC
            electrode_date: null,
            expendable_date: null,
            electrode_first: false,
            catheter_date: null           
        }
    },
    pre_delegation_info: {
        profile_id: 0,
        is_loading: false,  // 작성중인지 표시 (페이지에 직접 접근할경우 초기 화면으로 이동시킴 )
        // 기존 위임 정보 (option) // 5번으로 이동 
        is_delegated: false,
        started_at: null,
        expired_at: null
    },
    cardInfo: {
        card_number: "",
        card_pw: "",
        card_ex_month: "",
        card_ex_year: "",
        card_nick_name: "",
        card_user_name: "",
        card_user_birth: ""
    },
    delivery: {
        address: "",
        detail_address: "",
        zip_code: "",
        address_nickname: "",
        address_description: ""
    }
}


// WEBPACK FOOTER //
// ./src/store/state.js